<template>
  <v-form v-model="valid" ref="form" v-bind="this.$attrs">
    <v-row>
      <v-col cols="12">
        <v-text-field
          dense
          outlined
          v-model="contactName"
          label="Họ và tên"
          placeholder="Nhập họ và tên người liên hệ"
          required
        ></v-text-field>
        <v-text-field
          dense
          outlined
          v-model="contactPhone"
          label="Số điện thoại"
          placeholder="Nhập số điện thoại người liên hệ"
        ></v-text-field>
        <v-text-field
          dense
          outlined
          v-model="contactAddress"
          label="Địa chỉ"
          placeholder="Nhập địa chỉ người liên hệ"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'

export default {
  props: {
    student: {
      type: [Object],
      required: true,
      default: () => {},
    },
  },
  data: () => ({
    valid: true,
    contactName: '',
    contactPhone: '',
    contactAddress: '',
  }),
  computed: {
    ...mapState('auth', ['role']),
  },
  created() {
    this.reset()
  },
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.contactName = get(this.student, 'data.contactName', '')
      this.contactPhone = get(this.student, 'data.contactPhone', '')
      this.contactAddress = get(this.student, 'data.contactAddress', '')
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        contactName: this.contactName,
        contactPhone: this.contactPhone,
        contactAddress: this.contactAddress,
      }
    },
  },
  watch: {
    student(student) {
      this.reset()
    },
  },
}
</script>

<style scoped></style>
